import type { ReactNode } from 'react';
import { Search } from 'lucide-react';
import { colorSchemeLightCold, themeQuartz } from 'ag-grid-community';

export const managementTableTheme = themeQuartz.withPart(colorSchemeLightCold).withParams({
  fontFamily: 'Inter, system-ui, sans-serif',
  fontSize: 11.5,
  rowHeight: 32,
  headerHeight: 32,
  borderRadius: 6,
  headerBackgroundColor: '#f8fafc',
  borderColor: '#e2e8f0',
  oddRowBackgroundColor: '#f8fafc',
});

export default function ManagementTablePanel({ search, onSearch, label, count, toolbar, actions, children }: {
  search: string;
  onSearch: (value: string) => void;
  label: string;
  count: number;
  toolbar?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
}) {
  return (
    <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden rounded-xl border border-slate-200 bg-white">
      <div className="flex flex-wrap items-center justify-between gap-3 border-b border-slate-200 p-3">
        <div className="flex min-w-0 flex-1 flex-wrap items-center gap-3">
        <label className="flex w-full items-center gap-2 rounded-lg border border-slate-200 px-3 py-2 text-slate-400 sm:max-w-sm">
          <Search size={16} className="shrink-0" />
          <input type="search" aria-label={label} placeholder={label} value={search} onChange={event => onSearch(event.target.value)} className="min-w-0 w-full bg-transparent text-sm text-slate-700 outline-none" />
        </label>
          {toolbar}
        </div>
        <div className="flex flex-wrap items-center gap-3">
          <span className="text-xs text-slate-500">{count.toLocaleString('tr-TR')} kayıt</span>
          {actions}
        </div>
      </div>
      {children}
    </div>
  );
}
